import type { Dispatch } from "redux";
import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export function cancelSl() {
	return (dispatch) => {
		dispatch(actions.cancelSlRequest());
		return server.cancelSl(true).then(() => dispatch(actions.cancelSlResponse()));
	};
}

export interface EPKSamtykker {
	slKundesamtykke: boolean;
	loSamtykke?: boolean;
}

export function setSlKundeSamtykke(value: boolean) {
	return async (dispatch: Dispatch) => {
		dispatch(actions.setSlkundesamtykkeResponse(value));
	};
}

export function setSlInformasjonSamtykke(value: boolean) {
	return async (dispatch: Dispatch) => {
		dispatch(actions.setSlinformasjonsamtykkeResponse(value));
	};
}
